import styled from 'styled-components';

export default styled.p`
  color: ${({ theme }) => theme.colors.elements.warning};
  margin-bottom: 5px;
`;
